import { Component } from 'react';
import Quote from './common/molecules/Quote';
import ContentOuterBound from './common/atoms/ContentOuterBound';
import ContentSpacer from './common/atoms/ContentSpacer';
import * as InternalPropTypes from '../constants/internal-types';
import {
  TypeQuoteTypes,
  BackgroundColorEnum,
} from '../constants/cms-constants';
import QuoteCarouselMolecule from './common/molecules/QuoteCarousel';

type QuoteCarouselProps = {
  lightHeaderText?: InternalPropTypes.RichText;
  backgroundColor?: InternalPropTypes.hexCode;
  quotes?: InternalPropTypes.MediaItem[];
  type?: TypeQuoteTypes;
};

class QuoteCarousel extends Component<QuoteCarouselProps> {
  static types = Quote.types;

  static defaultProps = {
    lightHeaderText: null,
    backgroundColor: BackgroundColorEnum.WHITE,
    quotes: [],
    type: this.types.SINGLE,
  };

  render() {
    const { lightHeaderText, backgroundColor, quotes, type } = this.props;

    const addStyle = backgroundColor ? { background: backgroundColor } : {};
    return (
      <div css={addStyle} className="quote-carousel-component">
        <ContentOuterBound>
          <ContentSpacer>
            <QuoteCarouselMolecule
              lightHeaderText={lightHeaderText}
              type={type}
              quotes={quotes}
            />
          </ContentSpacer>
        </ContentOuterBound>
      </div>
    );
  }
}

export default QuoteCarousel;
